import { createContext } from 'react';

export const GridContext = createContext({
  gutter: 24,
  isNested: false, // First grid is not nested (`isNested = false`) - see `Grid.js` for nested `Grid`s
});
